<div class="input-group d-flex position-relative message mt-1 thread-input-group" [ngClass]="{'edit-mode': updateMode}">
    @if(!updateMode && userInfos){
        <div class="anonymous-addon" (click)="thread.isAnonymous = !thread.isAnonymous">
            @if(!thread.isAnonymous){
                @if(userInfos.firstname && userInfos.lastname){
                    <username-icon context="threadInput"
                                   [userInfos]="userInfos"></username-icon>
                }
                @else{
                    <i class="fa-solid fa-mask" [matTooltip]="'comment-card.non-anonymous-mode' | translate " matTooltipPosition="above"></i>
                    <span class="mask-crossed">
                        <i class="fal fa-times animate__animated animate__rotateIn"></i>
                    </span>
                }
            } @else {
                <i class="fa-solid fa-mask" [matTooltip]="'comment-card.anonymous-mode' | translate "
                    matTooltipPosition="above"></i>
            }
        </div>
    }
    

    @if (!hideTextareaPlaceholder){
        <div class="thread-textarea-placeholder">
              <textarea (focus)="hideTextareaPlaceholder = true" #newThreadInput 
                        placeholder="{{(thread.isAnonymous ? 'comment-card.discuss_placeholder' : 'comment-card.discuss_placeholder_non_anonymous') | translate}}"
                        class="form-control thread-input input-initial-state"
                        aria-describedby="anonymous-addon"></textarea>
        </div>
    } 
    @else{
        <!--    edit mode -->
        <div class="share-edu-info-container d-none">
            @if(isFieldEmplty){
            <div class="share-edu-info share-edu-info-text-first position-absolute"><i
                    class="fa-solid fa-arrow-left pe-2"></i>{{'share-edu-info.description-write' | translate }}</div>
            } @else {
            <div class="share-edu-info share-edu-info-text-second position-absolute"><i
                    class="fa-solid fa-arrow-left pe-2"></i>{{'share-edu-info.description-click' | translate }}</div>
            }
        </div>

        <tm-rich-text-area [cdkTrapFocusAutoCapture]="hideTextareaPlaceholder" [cdkTrapFocus]="hideTextareaPlaceholder" 
                            [(content)]="rtaContent"
                            (contentChange)="onContentChange($event)"
                            [threadAuthors]="threadAuthors"
                            [placeholderText]="(thread.isAnonymous ? 'comment-card.discuss_placeholder_anonymous' : 'comment-card.discuss_placeholder_non_anonymous') | translate"
                            [customStyles]="{'width': '100%', 'background-color': 'white', 'font-size': '14px'}"
                            class="tm-rich-text-area" #richTextAreaComponent></tm-rich-text-area>

        <div class="textarea-actions">
            <div class="d-flex justify-content-end align-items-baseline">
                <div class="thread-anonymity-toggler" [ngClass]="updateMode ? 'ps-sm-2 pe-sm-3': 'ps-2 pe-3'">
                    <mat-button-toggle-group>
                        <mat-button-toggle (click)="setAnonymity(true)" [checked]="$safeNavigationMigration(thread?.isAnonymous)">{{'anonymous' | translate}}</mat-button-toggle>
                        <mat-button-toggle (click)="setAnonymity(false)" [checked]="!thread?.isAnonymous" data-cy="anonymous-thread">{{'non_anonymous' | translate}}</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div class="thread-to-edit-actions">
                    <button (click)="save()" type="button"
                            [disabled]="isFieldEmplty"
                            class="thread-to-edit-actions-update" 
                            [ngClass]="{'disabled': isFieldEmplty}">
                        {{'save' | translate }} <i class="far fa-check"></i>
                    </button>
                    <button (click)="cancelUpdates()" class="ps-2 align-middle thread-to-edit-actions-cancel">
                        <i class="far fa-times-circle"></i>
                    </button>
                </div>
            </div>
        </div>
    }
</div>